var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group checkboxes" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row flex-options genre__container" },
      _vm._l(_vm.sortedItems, function (item) {
        return _c("div", { key: item.id, staticClass: "check-box-container" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.internalSelectedGenres,
                expression: "internalSelectedGenres",
              },
            ],
            staticClass: "checkbox-inline",
            attrs: { type: "checkbox", id: _vm.getInputId(item.id) },
            domProps: {
              value: item,
              checked: Array.isArray(_vm.internalSelectedGenres)
                ? _vm._i(_vm.internalSelectedGenres, item) > -1
                : _vm.internalSelectedGenres,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.internalSelectedGenres,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = item,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.internalSelectedGenres = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.internalSelectedGenres = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.internalSelectedGenres = $$c
                  }
                },
                _vm.onChange,
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "checkbox-inline",
              attrs: { for: _vm.getInputId(item.id) },
            },
            [_vm._v(_vm._s(item.name))]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("label", [_vm._v("Musiikkityylit")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }